import {
  Directive,
  HostListener,
  ElementRef,
  Renderer2,
  Output,
  EventEmitter,
  Input,
  HostBinding
} from '@angular/core';
import { Observable } from 'rxjs';

export interface EditUpdate {
  id: number;
  update: string;
  value: string;
}

@Directive({
  selector: '[click-edit]'
})
export class ClickEditDirective {
  value: string;
  placeholderValue: string = 'AudioStory name';
  @Input() allowEdit: boolean = true;
  @Input() id: number;
  @Input() update: string;

  @Output() onChange: EventEmitter<EditUpdate> = new EventEmitter();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostBinding('class.editable') isEditable: boolean;

  @HostListener('click', ['$event']) onClick(event) {
    if (this.allowEdit) {
      this.makeEditable();
    }
  }

  @HostListener('blur') blurred() {
    this.checkValues();
  }

  @HostListener('keydown', ['$event']) onKeydown(event) {
    const key = event.which || event.keyCode;
    if (key === 13) {
      event.preventDefault();
      this.checkValues();
    }
  }

  makeEditable() {
    this.isEditable = true;
    this.renderer.addClass(this.el.nativeElement, 'editable');
    this.renderer.setAttribute(this.el.nativeElement, 'contentEditable', 'true');
    this.el.nativeElement.focus();
    this.setValue(this.el.nativeElement.textContent);
  }

  checkValues(): Observable<EditUpdate> {
    if (this.el.nativeElement.textContent === '') {
      this.el.nativeElement.textContent = this.placeholderValue;
    }
    const newValue = this.el.nativeElement.textContent;

    if (this.value !== newValue) {
      const edit: EditUpdate = {
        id: this.id,
        update: this.update,
        value: newValue
      };
      this.onChange.emit(edit);
    }
    this.reset();
    return this.onChange;
  }

  reset() {
    this.isEditable = false;
    this.renderer.removeClass(this.el.nativeElement, 'editable');
    this.renderer.setAttribute(this.el.nativeElement, 'contentEditable', 'false');
  }

  setValue(value: string): string {
    if (value === this.placeholderValue) {
      value = '';
    }
    this.el.nativeElement.textContent = value;
    this.value = value;
    return this.value;
  }
}
